import { render } from "./InventarioDiferenciasPage.vue?vue&type=template&id=1e6cdf70&scoped=true"
import script from "./InventarioDiferenciasPage.vue?vue&type=script&lang=js"
export * from "./InventarioDiferenciasPage.vue?vue&type=script&lang=js"

import "./InventarioDiferenciasPage.vue?vue&type=style&index=0&id=1e6cdf70&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6cdf70"]])

export default __exports__